import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
@Component({
  standalone: true,
  selector: 'atom-box-multiple-genre',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './box-multiple-genre.atom.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoxMultipleGenreAtom implements OnInit {
  @Input() class = 'border-b';
  @Input() currentGenres!: any[];
  @Input() noGenre = 'ban chua chon gi ca';
  @Input() inputControl = new FormControl();
  constructor() {}

  ngOnInit(): void {}
}
